var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{class:!_vm.currentModal ? '' : _vm.$style.noscroll},[_c('div',{class:_vm.$style.main},[_c('h1',{class:_vm.$style.headingUsers},[_vm._v(_vm._s(_vm.$t('USERS')))]),_c('h4',[_vm._v(_vm._s(_vm.$t('ADMINISTRATORS')))]),_c('UserManagement')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }